import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
//custom imports
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import AvailableRooms from "./Recenttransactions";
//import Actions from "./components/Actions";
//import TabPanel from "./components/Tab"
//
function TRS() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <br />
      <Grid >
        <AvailableRooms />
      </Grid>
      <Footer />
    </DashboardLayout>
  );
}
export default TRS;
